export const STUDENT_STORE_KEY = 'students';

export const STUDENT_INFO_STORE_KEY = 'studentInfos';

export type StudentInfoId = number;
